export enum Colors {
    color_1 = "color_1",
    color_2 = "color_2",
    color_3 = "color_3",
    color_4 = "color_4",
    color_5 = "color_5",
    color_6 = "color_6",
    color_7 = "color_7",
    color_8 = "color_8",
    color_9 = "color_9",
    color_10 = "color_10",
    color_11 = "color_11",
    color_12 = "color_12",
    color_13 = "color_13",
    color_14 = "color_14",
    color_15 = "color_15",
    color_16 = "color_16",
    color_17 = "color_17",
    color_18 = "color_18",
    color_19 = "color_19",
    color_20 = "color_20",
    color_21 = "colors_21",
    color_22 = "color_22",
    color_23 = "color_23",
    color_24 = "color_24",
    color_25 = "color_25",
    color_26 = "color_26",
    color_27 = "color_27",
    color_28 = "color_28",
    color_29 = "color_29",
    color_30 = "color_30",
    color_31 = "color_31",
    color_32 = "color_32",
    color_33 = 'color_33',
    color_34 = 'color_34',
    color_35 = "color_35",
    color_36 = "color_36",
    color_37 = "color_37",
    color_38 = "color_38",
    color_39 = "color_39",
    color_40 = "color_40"

}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/resources/colors.ts